// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"34":"e2b053cd","519":"9794ca70","864":"91c6c253"}[chunkId] + ".chunk.css";
};